export default "__VITE_ASSET__BgpPy3Ld__"